import api from "./api.ts";
import type { AxiosResponse } from "axios";
import type { StudentSection } from "../interfaces/studentSection.interface.ts";

export async function completeSection(courseType: string, sectionIndex: number): Promise<StudentSection> {
    const response: AxiosResponse<StudentSection> = await api.patch("/section/complete", { courseType, sectionIndex });
    return response.data;
}

export async function getSections(): Promise<StudentSection[]> {
    const response: AxiosResponse<StudentSection[]> = await api.get("/section/all");
    return response.data;
}